<template>
  <div>
    <my-asidebar v-bind:active-tab="'port'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Liman</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Liman</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <port-list></port-list>
      </div>
    </section>

  </div>
</template>

<script>
import PortList from "../component/port/PortList";
import PortDetail from "../component/port/PortDetail";
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";


export default {
  name: "PortListPage",
  components: {MyAsidebar,  PortDetail, PortList,  TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_PORT_LIST"]) this.$router.push("/");
  }
}
</script>

<style scoped>

</style>